import { Permission, UserTier } from '@/entities/permissions/types';

// Granted to ALL tiers including Public and Expired
const UNIVERSAL_PERMISSIONS = new Set<Permission>([
  Permission.ViewIndexInformationBasic,
  Permission.ViewIndexInformationExtendedInfo
]);

const BASIC_PERMISSIONS = new Set<Permission>([
  Permission.ExportView,
  Permission.ViewCatalogDetails,
  Permission.ViewMarketScreens,
  Permission.ViewChartInFullscreen,
  Permission.ExportImage
]);

const API_PERMISSIONS = new Set<Permission>([Permission.ExportViaApi, Permission.GenerateApiToken]);

const PREMIUM_PERMISSIONS = BASIC_PERMISSIONS.union(
  new Set<Permission>([
    Permission.ViewIndexInformationChart,
    Permission.ExportDataChartPreview,
    Permission.UseSmallChartWatermark,
    Permission.ExportBasic,
    Permission.ExportViaApi,
    Permission.ViewPastExports,
    Permission.GenerateApiToken,
    Permission.DashboardPremiumWidgets
  ])
);

const GRANTS = new Map<UserTier, Set<Permission>>([
  [UserTier.Trial, BASIC_PERMISSIONS],
  [UserTier.Basic, BASIC_PERMISSIONS],
  [UserTier.PremiumNoApi, PREMIUM_PERMISSIONS.difference(API_PERMISSIONS)],
  [UserTier.Premium, PREMIUM_PERMISSIONS]
]);

export const hasPermissionForTier = (tier: UserTier, permission: Permission): boolean =>
  UNIVERSAL_PERMISSIONS.has(permission) || (GRANTS.get(tier)?.has(permission) ?? false);
